/**
 * システム設定(排出利用規約)
 */
import Vue from 'vue'
import * as httpConst from '../../../constants/httpConst'
import * as types from '../../mutation-types/admin-types'

const API_PATH = `${httpConst.ADMIN_ENDPOINT}/system_settings`

const system_setting = {
  namespaced: true,
  actions: {
    show ({ commit }) {
      const api_path = `${API_PATH}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
    update ({ commit },{ params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.put(API_PATH, params ).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
}

export default system_setting
